import ChartView from "pro-features/components/Chart/src/Chart";
import { useState, useEffect, useMemo } from "react";
import { getChartConfig } from "./chartConfig";
import { useSocialTrafficContext } from "app/pages/website-analysis/social-overview/socialTraffic/context";
import type { IChartData } from "app/pages/website-analysis/social-overview/socialTraffic/chartData";
import { getChartData } from "app/pages/website-analysis/social-overview/socialTraffic/chartData";
import { NoData } from "app/pages/keyword-analysis/TotalTrafficPage/Components/UtilityComponents";

export const Chart = () => {
    const socialTrafficContext = useSocialTrafficContext();
    const { legendItems } = socialTrafficContext;
    const [isError, setIsError] = useState<boolean>(false);
    const [chartData, setChartData] = useState<IChartData>([]);
    useEffect(() => {
        setIsError(false);
        getChartData(socialTrafficContext)
            .then((chartData) => {
                setChartData(chartData);
            })
            .catch(() => setIsError(true));
    }, []);

    const filteredChartData = useMemo(() => {
        return chartData.filter(({ name: siteName }) => {
            return legendItems.some(({ name, visible }) => name === siteName && visible);
        });
    }, [legendItems, chartData]);
    const categories = filteredChartData[0]?.data.map(({ key }) => key);
    const chartConfig = getChartConfig(socialTrafficContext, categories, filteredChartData);
    const isNoData = !filteredChartData || filteredChartData.length === 0 || isError;
    return isNoData ? (
        <NoData
            paddingTop="10px"
            paddingBottom="30px"
            noDataTitleKey="global.nodata.notavilable"
            noDataSubTitleKey="workspaces.marketing.nodata.subtitle"
        />
    ) : (
        <ChartView
            type={"column"}
            data={filteredChartData}
            config={chartConfig}
        />
    );
};
